import { CategoryCardType } from "@/types/CategoryType";
import Image from "next/image";
import Link from "next/link";
import React from "react";

function CategoryCard({ category, className }: CategoryCardType) {
  const categoryCard = ` rounded-[1.5rem]	relative flex justify-center items-center cursor-pointer cat-wrapper w-full pt-[100%]`;
  const contentFull = `w-full h-full`;
  const categoryMask = `bg-ws-gray-900 opacity-65  mask absolute inset-0`;
  const categoryText = `w-full h-full absolute inset-0 flex items-center justify-center font-normal  text-ws-white-100   text-center text-base lg:text-base z-50`;
  const classNameCategoryCard = `${className} xl:rounded-[2rem] lg:rounded-[1.5rem] rounded-[1rem] `;
  const CategoryCardRounded = `xl:rounded-[2rem] lg:rounded-[1.5rem] rounded-[1rem] `;
  return (
    <Link
      href={`/category/${category?.name}/${category?.id}`}
      key={category?.id}
      className={`${categoryCard} ${classNameCategoryCard} relative`}
    >
      <div className="absolute inset-0">
        <Image
          unoptimized
          width={50000}
          height={30000}
          quality={100}
          className={`${contentFull} ${classNameCategoryCard} object-cover`}
          src={category?.icon ? category?.icon : "/images/default.png"}
          alt=""
        />
      </div>
      <span className={`${categoryText}`}>{category?.name}</span>
      <span
        className={`${categoryMask} ${contentFull} ${CategoryCardRounded} ${classNameCategoryCard}`}
      ></span>
    </Link>
  );
}

export default CategoryCard;
